import { List } from "@phosphor-icons/react";
import type React from "react";

import { Menu, MenuButton, MenuList } from "../Menu";

export const MobileNav: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Menu placement="start">
      <MenuButton className="btn btn-square btn-ghost">
        <List className="size-7" />
      </MenuButton>
      <MenuList>
        <ul className="menu">{children}</ul>
      </MenuList>
    </Menu>
  );
};
